import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../constatns/colors";
import useWindowDimensions from "../../constatns/size";
import "../../styles/home.css";

function TokenDetailSection({description}) {
    const { width, height } = useWindowDimensions();
    
  return (
        <Container width={width} height={height} id="about">
            <InnerContainer width={width} height={height}>
                <div style={{position: "relative"}}>
                    <img style={{position: "absolute", width: 25, height: 25, top:  12, left: 12}} alt="detail" src={require("../../assets/images/dex.png")}  />
                    <img style={{width: 45, height: 45}} alt="detail" src={require("../../assets/images/circle.png")} />
                </div>
                <Description>{description}</Description>
            </InnerContainer>
        </Container>
  );
}

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
`

const InnerContainer = styled.div`
    display: flex;
    color: ${colors.white};
    width: 90%;
    /* width: ${({width})=> width/5.5}px; */
`
const Description = styled.p`
    color: ${colors.white};
    font-size: 14px;
    padding-left: 10px;
    margin: 0px;
    line-height: 1.5;
`
export default TokenDetailSection;
